import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface IpLocationData{ 
  countrycode: string, 
  countryname: string, 
  detail: string, 
  ip: string, 
  registry: string, 
  spam: boolean, 
  tor: boolean
}

@Injectable({
    providedIn: 'root'
})

export class IpLocationService {
  constructor( private http: HttpClient ) { }
  
  public getLocation(): Observable<IpLocationData>{  
    return this.http.get<IpLocationData>('https://iplist.cc/api/');
  }
}